import { productionHosts } from "components/configuration";

export function isProductionHost() {
  return productionHosts.includes(location.host);
}
